export const formatUSDBalance = (bal) => {
  return Math.floor(bal * 100) / 100;
};
